import { PageId } from 'constants/pages'

export const enum PageIdStylioCapsule71 {
  SUBSCRIPTIONS_CAPSULE_71 = PageId.SUBSCRIPTIONS_CAPSULE_71,
  SUB_UPSELL_CAPSULE_71 = PageId.SUB_UPSELL_CAPSULE_71,
  FACE_STYLING_PDF_UPSELL_CAPSULE_71 = PageId.FACE_STYLING_PDF_UPSELL_CAPSULE_71,
  PROPORTIONS_PDF_UPSELL_CAPSULE_71 = PageId.PROPORTIONS_PDF_UPSELL_CAPSULE_71,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPSULE_71 = PageId.DOWNLOAD_CAPSULE_71,
}
